import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { comparisonRows, methodPhases } from '../data/objections';
import { Reveal } from './ui/Reveal';
export function Method12Section() {
  return <section aria-labelledby="metodo-title" className="border-b border-line bg-ink" data-id="element-152" data-mp="2ot0q2wme4456">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 lg:py-24" style={{
      paddingTop: "15px"
    }} data-id="element-153" data-mp="2suvontcxs3f9">
        <div className="mx-auto max-w-2xl text-center" style={{
        paddingBottom: "0px"
      }} data-id="element-154" data-mp="1w5elbl1fetgq">
          <h2 id="metodo-title" className="text-2xl font-black leading-tight tracking-tight text-ivory sm:text-3xl lg:text-4xl" style={{
          fontSize: "18px",
          fontWeight: "500"
        }} data-id="element-155" data-mp="213pt7q85utwb">
            ¿Qué agrega el Método 12 Semanas?
          </h2>
          <p className="mt-4 text-base text-muted sm:text-lg" style={{
          fontSize: "12px"
        }} data-id="element-156" data-mp="29xko85fkj3y8">
            La misma situación, con y sin implementación guiada.
          </p>
        </div>

        <div className="mx-auto mt-8 max-w-3xl overflow-hidden rounded-2xl border border-line" data-id="element-157" data-mp="1hefcqa0lc4x5">
          <table className="w-full table-fixed border-collapse" data-id="element-158" data-mp="27k48gskhsrvx">
            <caption className="sr-only" data-id="element-159" data-mp="22lapwlqcmaow">
              Comparación entre el MegaPack solo y el Método 12 Semanas
            </caption>
            <thead data-id="element-160" data-mp="1xszrjnb9awyg">
              <tr className="bg-surfaceAlt" data-id="element-161" data-mp="1xshljyysl4dc">
                <th scope="col" className="w-1/2 px-3 py-3 text-center text-[11px] font-black uppercase tracking-wide text-danger sm:px-5 sm:text-xs" data-id="element-162" data-mp="1swj0olcoa4ho">
                  <span className="inline-flex items-center gap-1.5" data-id="element-163" data-mp="1nubmdp4decc6">
                    <XIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" data-id="element-164" data-mp="1jthz8xyr51kc" />
                    Solo Tomos + Bonos
                  </span>
                </th>
                <th scope="col" className="w-1/2 border-l border-line px-3 py-3 text-center text-[11px] font-black uppercase tracking-wide text-success sm:px-5 sm:text-xs" data-id="element-165" data-mp="19xf0m233zl25">
                  <span className="inline-flex items-center gap-1.5" data-id="element-166" data-mp="34awmlknv89v2">
                    <CheckIcon aria-hidden="true" className="h-3.5 w-3.5 shrink-0" data-id="element-167" data-mp="34bpjzv0xpn0j" />
                    Método 12 Semanas
                  </span>
                </th>
              </tr>
            </thead>
            <tbody data-id="element-168" data-mp="17ejwxk8qek7y">
              {comparisonRows.map(row => <tr key={row.situation} className="border-t border-line bg-surface align-top" data-id="element-169" data-mp="socc4xv94p43">
                  <td className="px-3 py-3 text-[12px] leading-snug text-muted sm:px-5 sm:py-4" data-id="element-170" data-mp="xm4fqp59dzo4">
                    {row.without}
                  </td>
                  <td className="border-l border-line px-3 py-3 text-[12px] font-semibold leading-snug text-success sm:px-5 sm:py-4" data-id="element-171" data-mp="1la5hnf7xmhuk">
                    {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 rounded-2xl border border-line bg-surface p-6 sm:p-8" data-id="element-172" data-mp="1gc3zqxm8soko">
          <h3 className="text-center text-base font-black uppercase tracking-wide text-ivory sm:text-lg" data-id="element-173" data-mp="3w3rsegu83uxo">
            El Método 12 Semanas incluye
          </h3>

          <ol className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-174" data-mp="4vm2wweqgjxi">
            {methodPhases.map((phase, i) => <Reveal key={phase.weeks} delay={i * 0.03} className="h-full" data-id="element-175" data-mp="2j7ki1xien1e1" data-mpi={i}>
                <li className="flex h-full flex-col rounded-xl border border-line bg-surfaceAlt p-4" data-id="element-176" data-mp="2e6endu56p41v">
                  <p className="text-[10px] font-black uppercase tracking-wide text-accent" data-id="element-177" data-mp="2s4bon3ul1ymv">
                    {phase.weeks}
                  </p>
                  <p className="mt-1 text-sm font-bold tracking-tight text-ivory" data-id="element-178" data-mp="20egosd93mqjy">{phase.name}</p>
                  <p className="mt-2 flex items-start gap-2 text-[12px] leading-snug text-muted" data-id="element-179" data-mp="1vgybybrynr6o">
                    <CheckIcon aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-success" data-id="element-180" data-mp="297tpi1demwgl" />
                    {phase.focus}
                  </p>
                </li>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}